import React from "react";
import { categories } from "../../data/wholesaleProducts";
import policies from "../../data/policyCatalog";

const supportLinks = ["shipping", "returns", "payments", "refunds", "contact"];
const companyLinks = ["privacy", "terms", "accessibility", "sustainability", "materials"];

export default function FooterBar({ shop, openPolicy, go, BrandMark }) {
  return (
    <footer className="bg-[#17234b] text-[#f7f7f2]">
      <div className="mx-auto max-w-[1440px] px-5 pb-8 pt-16 lg:px-10 lg:pt-20">
        <div className="grid gap-12 border-b border-white/15 pb-14 lg:grid-cols-[1.2fr_0.8fr] lg:items-end">
          <div>
            <button onClick={() => go("home")} className="font-serif text-4xl text-[#c8e84b]" aria-label="Calveron home">
              <BrandMark />
            </button>
            <h2 className="mt-7 max-w-2xl font-serif text-4xl leading-[1.05] tracking-[-0.03em] sm:text-5xl">
              A brighter place for plans, notes and everyday ideas.
            </h2>
          </div>
          <div className="lg:justify-self-end">
            <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-[#ffb37b]">The Calveron note</p>
            <p className="mt-3 max-w-md text-sm leading-6 text-white/60">
              New paper goods, thoughtful ideas and occasional encouragement.
            </p>
            <form onSubmit={(event) => event.preventDefault()} className="mt-5 flex max-w-md border-b border-white/40 pb-3">
              <input required type="email" placeholder="Email address" aria-label="Email address" className="min-w-0 flex-1 bg-transparent text-sm outline-none placeholder:text-white/35" />
              <button className="ml-5 text-[10px] font-bold uppercase tracking-[0.14em] text-[#c8e84b]">Subscribe →</button>
            </form>
          </div>
        </div>

        <div className="grid gap-10 py-12 sm:grid-cols-3 lg:grid-cols-[1fr_1fr_1fr_1.6fr]">
          <nav className="flex flex-col items-start gap-3" aria-label="Footer shop navigation">
            <b className="mb-2 text-[9px] uppercase tracking-[0.18em] text-[#ffb37b]">Shop</b>
            {categories.slice(1).map((category) => <button onClick={() => shop(category)} key={category} className="text-sm text-white/70 transition hover:text-white">{category}</button>)}
          </nav>
          <nav className="flex flex-col items-start gap-3" aria-label="Customer support">
            <b className="mb-2 text-[9px] uppercase tracking-[0.18em] text-[#ffb37b]">Customer care</b>
            {supportLinks.map((key) => <button onClick={() => openPolicy(key)} key={key} className="text-sm text-white/70 transition hover:text-white">{policies[key].nav}</button>)}
          </nav>
          <nav className="flex flex-col items-start gap-3" aria-label="Company information">
            <b className="mb-2 text-[9px] uppercase tracking-[0.18em] text-[#ffb37b]">About Calveron</b>
            {companyLinks.map((key) => <button onClick={() => openPolicy(key)} key={key} className="text-sm text-white/70 transition hover:text-white">{policies[key].nav}</button>)}
          </nav>
          <div className="lg:border-l lg:border-white/15 lg:pl-10">
            <p className="text-[9px] font-bold uppercase tracking-[0.18em] text-[#ffb37b]">Good to know</p>
            <p className="mt-4 max-w-sm text-sm leading-6 text-white/55">
              Free U.S. shipping over $40. Orders are normally prepared within two business days.
            </p>
            <button onClick={() => openPolicy("shipping")} className="mt-6 border-b border-[#c8e84b] pb-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#c8e84b]">Read delivery details</button>
          </div>
        </div>

        <details className="group border-y border-white/15 py-5">
          <summary className="flex cursor-pointer list-none items-center justify-between text-[10px] font-bold uppercase tracking-[0.18em]">
            <span>All policies</span>
            <span className="text-xl font-light text-[#c8e84b] transition group-open:rotate-45">+</span>
          </summary>
          <div className="grid gap-x-8 gap-y-3 pb-3 pt-7 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {Object.entries(policies).map(([key, policy]) => (
              <button onClick={() => openPolicy(key)} key={key} className="text-left text-xs text-white/55 transition hover:text-white">
                {policy.nav}
              </button>
            ))}
          </div>
        </details>

        <div className="flex flex-col justify-between gap-4 pt-8 text-[9px] uppercase tracking-[0.14em] text-white/40 sm:flex-row sm:items-center">
          <span>© 2026 Calveron Paper Co.</span>
          <div className="flex flex-wrap gap-5">
            <button onClick={() => openPolicy("privacy")} className="hover:text-white">Privacy</button>
            <button onClick={() => openPolicy("terms")} className="hover:text-white">Terms</button>
            <button onClick={() => openPolicy("accessibility")} className="hover:text-white">Accessibility</button>
          </div>
          <span>Made for beautifully full days.</span>
        </div>
      </div>
    </footer>
  );
}

